import { Market } from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetMarketApi = async (id: string): Promise<Market> => {
  const result = await executeGql<Market>(adminGetMarketQuery, { id });
  return processGqlResult<Market>('adminGetMarket', result);
};

const adminGetMarketQuery = /* GraphQL */ `
  query AdminGetMarket($id: String!) {
    adminGetMarket(id: $id) {
      countryCode
      country
      createdAt
      currency
      id
      location {
        lat
        lon
      }
      name
      stateProvince
      status
      timezone {
        dstOffset
        rawOffset
        timeZoneId
        timeZoneName
      }
      tipEnabled
      region
    }
  }
`;
